var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        no: "dialog",
        "append-to-body": "",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.SelectLocation"),
        width: "650px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": _vm.$selectByLang("60px", "70px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CityName") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "310px" },
                        attrs: {
                          no: "likeName",
                          placeholder: _vm.$t("common.tips.fuzzySearch")
                        },
                        model: {
                          value: _vm.filter.likeName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "likeName", $$v)
                          },
                          expression: "filter.likeName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { no: "query", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.filter.pageNum = 1
                              _vm.toQuery()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%" },
              attrs: {
                no: "grid",
                "show-side-bar": false,
                "grid-options": _vm.gridOptions,
                "side-bar": _vm.sideBarDefs,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: { gridReady: _vm.onGridReady }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "pagination-wrapper",
            staticStyle: { "padding-right": "0px" }
          },
          [
            _c("cargo-pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.total > 0,
                  expression: "total>0"
                }
              ],
              attrs: {
                no: "pagination",
                total: _vm.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: _vm.toQuery
              }
            })
          ],
          1
        )
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "add", type: "primary" },
              on: { click: _vm.addFromPlatform }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_add")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "cancel" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }